import { render, staticRenderFns } from "./SettingsModalBlock.vue?vue&type=template&id=01e35785"
import script from "./SettingsModalBlock.vue?vue&type=script&lang=js"
export * from "./SettingsModalBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports